import { JsonResponseType } from "~/types/jsonResponseType";
import { BaseApi } from "./baseApi";

type HeaderType = Record<string, string> | undefined;

interface BaseGraphQLCreationProps {
  baseUrl: string;
}

interface BaseGraphQLProps {
  action: string;
  variables: object;
  query: string;
  headers?: HeaderType;
  groupSid?: string;
}

interface TInputType<TInputData> {
  data: TInputData;
}

export const BaseGraphQL = ({ baseUrl }: BaseGraphQLCreationProps) => {
  const graphQLRequest = BaseApi({ baseUrl });

  return async <TResponse, TInputData>(
    { action, variables, query, headers = {}, groupSid }: BaseGraphQLProps,
    responseMapper: (input: TInputData) => JsonResponseType<TResponse>,
  ) => {
    return await graphQLRequest<TResponse, TInputType<TInputData>>({
      method: "POST",
      action,
      body: JSON.stringify({ query, variables }),
      headers,
      groupSid,
      responseMapper: (input) => {
        return responseMapper(input.data);
      },
    });
  };
};
